<template>
  <div class="flex flex-col gap-4">
    <div class="flex w-full gap-4 items-center">
      <h1 class="text-text-primary font-semibold text-[24px] flex-1">{{ $t('coach.shared.match_history') }}</h1>
      <svg v-if="loading" width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="animate-spin">
        <circle cx="16" cy="16" r="15" stroke="#1E2733" stroke-width="2" />
        <path d="M16 1C17.9698 1 19.9204 1.38799 21.7403 2.14181C23.5601 2.89563 25.2137 4.00052 26.6066 5.3934C27.9995 6.78628 29.1044 8.43986 29.8582 10.2597C30.612 12.0796 31 14.0302 31 16" stroke="#4E54C8" stroke-width="2" />
      </svg>
    </div>

    <div class="w-full flex flex-col gap-[2px] rounded-lg overflow-hidden">
      <!-- Header -->
      <div
        :class="[matches?.length > 0 ? 'px-4 py-2' : 'p-4']"
        class="bg-gray-900 text-text-primary text-xs tracking-[1.5px] flex-1 uppercase flex md:gap-2 items-center"
      >
        <div class="flex-1 md:flex-none">{{ $t('coach.match_history.last_n_matches', { n: matches?.length }) }}</div>
        <template v-if="matches?.length > 0">
          <span class="hidden md:block text-text-secondary">&bull;</span>
          <span
            class="hidden md:block"
            :class="{
              'text-success-400': recentStats?.win_rate > 50,
              'text-text-primary': recentStats?.win_rate == 50,
              'text-danger-400': recentStats?.win_rate < 50,
            }"
          >{{ recentStats?.win_rate }}%</span>
          <div class="flex-1 flex items-center">
            <h1 class="flex-1 hidden md:block">{{ $t('coach.match_history.win_ratio') }}</h1>
            <Pagination
              :currentPage="currentPage"
              :totalPages="totalPages"
              :showCount="false"
              @changePage="$emit('changePage', $event)"
            />
          </div>
        </template>
        <div v-else class="flex-1 hidden md:block" />
      </div>

      <!-- Match rows -->
      <template v-if="matches?.length > 0">
        <div v-for="match in matches" :key="match.match_id" class="bg-gray-900">
          <MatchRow :match="{ ...match, status: match.status || 'analyzed' }" />
        </div>
      </template>
      <i18n-t scope="global" v-else keypath="coach.match_history.none_found" tag="div" class="bg-gray-900 p-4 text-text-secondary text-xs tracking-[1.5px]">
        <template #link><router-link to="/settings" class="underline">{{ $t('coach.match_history.none_found_link') }}</router-link></template>
      </i18n-t>
    </div>
  </div>
</template>

<script setup>
import MatchRow from '../../UserProfile/MatchRow.vue';
import Pagination from '../../Pagination.vue';

defineProps({
  matches: Array,
  loading: Boolean,
  recentStats: Object,
  currentPage: Number,
  totalPages: Number,
});

defineEmits(['changePage']);
</script>
